import { render, staticRenderFns } from "./YzBtnToggle.vue?vue&type=template&id=4035d2cd&scoped=true&lang=pug&"
import script from "./YzBtnToggle.vue?vue&type=script&lang=js&"
export * from "./YzBtnToggle.vue?vue&type=script&lang=js&"
import style0 from "./YzBtnToggle.vue?vue&type=style&index=0&id=4035d2cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4035d2cd",
  null
  
)

export default component.exports